import { ReactNode, createContext, useContext } from 'react';
import { setCurrentApplicationHeader } from '../services/http';
import { ApplicationCode } from '../config/applications';

/**
 * Aplicacion activa (Control Operativo, Gestion Humana, ...). null = todavia
 * en el Selector de Aplicacion, sin haber entrado a ninguna.
 */
const ApplicationCodeContext = createContext<ApplicationCode | null>(null);

export function useApplicationContext(): { applicationCode: ApplicationCode | null } {
  const applicationCode = useContext(ApplicationCodeContext);
  return { applicationCode };
}

/**
 * Fija que aplicacion de la Suite esta activa. Debe envolver el shell de CADA
 * aplicacion (ver layouts/AppSection.tsx) - CurrentUserProvider y todo lo que
 * dependa de useApplicationContext() vive DEBAJO de este provider.
 *
 * IMPORTANTE: el header `X-Lcc-Application` (ver shared/services/http.ts) se
 * fija de forma SINCRONA durante el render (no en useEffect) - igual que
 * setTokenProvider en ClerkAuthProvider.tsx, y por la MISMA razon documentada
 * ahi: los useEffect de los componentes hijos (ej. la carga inicial de perfil
 * en CurrentUserProvider) se ejecutan ANTES que un useEffect de este
 * componente padre. Si el header se fijara en un useEffect aqui, esa primera
 * peticion saldria sin el header y el backend respondaria 400 "Aplicacion no
 * especificada". Al ser un valor plano (no estado de React) no hay problema
 * en fijarlo directamente en el cuerpo del componente.
 */
export function ApplicationProvider({ applicationCode, children }: { applicationCode: ApplicationCode; children: ReactNode }) {
  setCurrentApplicationHeader(applicationCode);
  return <ApplicationCodeContext.Provider value={applicationCode}>{children}</ApplicationCodeContext.Provider>;
}
